import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useSeek } from '../../hooks/useSeek';
import { useKeyboardHandler } from '../../hooks/useKeyboardHandler';
import { useIcons } from '../../hooks/useIcons';

const REWIND_DIFF_IN_SECONDS = 15;

export const RewindButton: FunctionComponent<IconButtonProps> = (props) => {
  const { rewindBy } = useSeek();
  const { Backward15 } = useIcons();

  const rewind = useCallback(() => {
    rewindBy(REWIND_DIFF_IN_SECONDS);
  }, [rewindBy]);

  const handleKeydown = useCallback(
    (e: KeyboardEvent) => {
      if (e.code === 'ArrowLeft') {
        rewind();
      }
    },
    [rewind]
  );

  useKeyboardHandler(handleKeydown);

  return (
    <IconButton onClick={rewind} {...props}>
      <Backward15 />
    </IconButton>
  );
};
